//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../goods/goods.less'
import addressList from '../address/list.vue'
export default {
    components: {
        addressList
    },
    data() {
        return {
            address: null,
            goodsList: [],
            totalPrice: 0,
            remark: '',
            addressPopupShow: false,
            blurFlag: true, // 焦点事件触发节流
            submitFlag: true, //提交按钮节流
        }
    },
    methods: {
        //有人说点击输入框效果不好
        remarkClickHandle() {
            $("#remarkTextarea textarea").focus();
        },
        focusHandle() {
            if (this.blurFlag) {
                // console.log("焦点移入")
                document.getElementById("remarkTextarea").scrollIntoView(true);
                document.getElementById("remarkTextarea").scrollIntoViewIfNeeded();
                $("#gbBtns").css("display", "none");
            }
        },
        blurHandle() {
            if (this.blurFlag) {
                // console.log("焦点移出")
                $("#gbBtns").css("display", "block");
                this.blurFlag = false;
            }
            setTimeout(() => {
                this.blurFlag = true;
            }, 300)

        },
        windowResize() {
            let that = this;
            var windowHeight = $(window).height();
            $(window).resize(function () {
                setTimeout(() => {
                    var changeHeight = $(window).height();
                    if (changeHeight < windowHeight) {
                        //焦点移入
                        console.log("焦点移入")
                        that.focusHandle();
                    } else {
                        //焦点移出
                        console.log("焦点移出")
                        that.blurHandle();
                    }
                }, 100);
            })
        },
        //地址选择组件返回事件
        addressGoBack(address) {
            if (address) {
                address.desc = address.regionDesc.replace(/\s/g, '') + address.address;
                this.address = address;
            }
            this.addressPopupShow = false;
        },
        getAddress() {
            let that = this;
            that.$axios.get("/api/v1.0/lonbonShop/receiverAddress", {
                params: {
                    shopperId: that.$store.state.userInfo.shopperId
                }
            }).then(function (res) {
                if (res.status == 200) {
                    let verificationResult = true
                    if (that.address && that.address.receiverAddressId) {
                        let result = res.body.some(item => {
                            // some   一真为真
                            if (item.defaultAddress == that.address.receiverAddressId) {
                                return true;
                            }
                        });
                        verificationResult = result
                    } else {
                        verificationResult = false
                    }
                    if (!verificationResult) {
                        var flag = false;
                        res.body.forEach((item) => {
                            if (item.defaultAddress == 1) {
                                item.desc = item.regionDesc.replace(/\s/g, '') + item.address;
                                that.address = item;
                                flag = true;
                            }
                        });
                        if (!flag && res.body.length > 0) {
                            var one = res.body[0];
                            one.desc = one.regionDesc.replace(/\s/g, '') + one.address;
                            that.address = one;
                            flag = true;
                        }
                        if (!flag) {
                            that.address = null;
                        }
                    }
                }
            })
        },
        //节流
        buttonFlag(code) {
            if (!this[code]) {
                this.$vux.toast.text('请不要快速点击');
                return false;
            } else {
                this[code] = false;
                setTimeout(() => {
                    this[code] = true;
                }, 1500);
                return true;
            }
        },
        submit() {
            if (!this.buttonFlag('submitFlag')) {
                return false;
            }
            if (!this.address || !this.address.name || !this.address.phoneNum || !this.address.desc) {
                this.$vux.toast.text('请选择收货地址');
                return false;
            }
            if (!this.goodsList || this.goodsList.length <= 0) {
                this.$vux.toast.text('没有商品信息，请返回首页重新选择购买');
                return false;
            }
            var orderCartIdList = [];
            var orderDetailsList = this.goodsList.map((item, index) => {
                item.buyNum = item.number;
                item.buyPrice = item.sellingPrice;
                item.shareDetail = item.shareDetail ? item.shareDetail : '分享描述';
                if (item.orderCartId) {
                    orderCartIdList.push(item.orderCartId);
                }
                item.photo = item.poster;
                if (!item.isSuit && item.isSuit != 0) {
                    item.isSuit = item.isSuitKey;
                }
                item.orderNum = index + 1;
                return item;
            })
            var goodsOrder = {
                goodsTotalPrices: this.totalPrice,
                discountsPrices: 0,
                freightPrices: 0,
                shippingMethod: 0,
                orderTotalPrices: this.totalPrice,
                customerMessage: this.remark,
                orderDetailsList: orderDetailsList,
                ...this.address
            }
            var data = {
                goodsOrder: JSON.stringify(goodsOrder),
                shopperId: this.$store.state.userInfo.shopperId
            }
            if (orderCartIdList && orderCartIdList.length > 0) {
                data.orderCartIdList = JSON.stringify(orderCartIdList);
            }
            let that = this;
            that.$axios.post('/api/v1.0/lonbonShop/buy', that.qs.stringify(data)).then(function (response) {
                if (response.status == 200) {
                    that.$store.state.APPPAGE.getOrderCartNum();
                    that.$router.push("/orderDetail?readyPayOrderId=" + response.body + "&openPay=true");
                }
            })
        }
    },
    mounted() {
        var goodsList = sessionStorage.readyBuyGoods;
        if (goodsList) {
            this.goodsList = JSON.parse(goodsList);
            var totalPrice = 0;
            this.goodsList.forEach((item) => {
                totalPrice += item.number * item.sellingPrice
            })
            this.totalPrice = totalPrice;
            this.getAddress();
        } else {
            this.$router.push("/goods");
        }
        this.windowResize();
    }
}



// WEBPACK FOOTER //
// ./src/components/buycar/goBuy.vue